module.exports = __webpack_public_path__ + "img/icon_alarm_bag.31851e78.png";